import OwnerOffers from "./OwnerOffers";

export default OwnerOffers;